import { Skeleton, Text, VStack } from '@wegroup/design-system';
import { useInsurancePoliciesBySimulation } from '@flows/src/api/anva-flows/simulation/getInsurancePoliciesBySimulation';
import { PartyType } from '@parties/src/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import InsurancePolicyItem from '@advisory-report/src/features/creation-flow/components/insurance-policies/shared/insurance-policy/InsurancePolicyItem';

interface Props {
  partyId: string;
  sessionId: string;
  partyType: PartyType;
  editable?: boolean;
  withDocuments?: boolean;
}

const YellowhiveProductPoliciesOverview: FC<Props> = ({
  partyType,
  partyId,
  sessionId,
  editable = false,
  withDocuments = false,
}) => {
  const { t } = useTranslation();
  const { data, isLoading } = useInsurancePoliciesBySimulation({
    partyId,
    simulationId: sessionId || '',
  });

  const policies =
    data?.items?.filter(({ policy_package_id }) => !policy_package_id) || [];

  if (isLoading)
    return (
      <VStack align="stretch" spacing="4">
        <Skeleton w="full" h="72" opacity="0.2" />
        <Skeleton w="full" h="72" opacity="0.2" />
      </VStack>
    );

  if (!policies.length) return null;

  return (
    <VStack align="stretch" spacing="4">
      <VStack align="stretch" spacing="1">
        <Text textStyle="h6Headline">
          {t(
            'ADVISORY-REPORTS_CREATION-FLOW_CURRENT-INSURANCES_SUB-TITLE-YELLOWHIVE',
          )}
        </Text>
        <Text textStyle="smallBody" color="gray.500">
          {t(
            'ADVISORY-REPORTS_CREATION-FLOW_CURRENT-INSURANCES_SUB-DESCRIPTION',
          )}
        </Text>
      </VStack>
      {policies.map((data, i) => (
        <InsurancePolicyItem
          key={data.id}
          insurancePolicy={data}
          controlled
          partyType={partyType}
          withActions={false}
          index={i}
          partyId={partyId}
          withDocuments={withDocuments}
        />
      ))}
    </VStack>
  );
};

export default YellowhiveProductPoliciesOverview;
